export const InternalVideoDocUrl = 'https://docs.yandex-team.ru/video/getting_started/start';
